import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getMantencionesByMarcaModelo } from '../../helpers/api_helper';

const useMantenciones = (marca, modelo) => {
    const [mantenciones, setMantenciones] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const tenantId = useSelector((state) => state.Context.tenantId);
    const empresa = useSelector((state) => state.Context.empresa);

    useEffect(() => {
        const fetchMantenciones = async () => {
            console.log('[useMantenciones] params:', { marca, modelo, tenantId, empresa });

            if (!marca || !modelo || !tenantId || !empresa) {
                console.log('[useMantenciones] early return - missing params');
                setMantenciones([]);
                return;
            }

            setLoading(true);
            setError(null);
            try {
                const response = await getMantencionesByMarcaModelo({
                    tenantId,
                    empresa,
                    marca,
                    modelo
                });
                console.log('[useMantenciones] response:', response);

                if (Array.isArray(response)) {
                    console.log('[useMantenciones] setting', response.length, 'items');
                    setMantenciones(response);
                } else {
                    console.log('[useMantenciones] unexpected response shape, isArray=', Array.isArray(response));
                    setMantenciones([]);
                }
            } catch (err) {
                console.error('[useMantenciones] error:', err);
                setError(`Error al cargar mantenciones: ${err.message}`);
                setMantenciones([]);
            } finally {
                setLoading(false);
            }
        };

        fetchMantenciones();
    }, [marca, modelo, tenantId, empresa]);

    return { mantenciones, loading, error };
};

export default useMantenciones;
